import { parseJSON } from '@/components/TicketModal/utils';
import { IAction } from '../types';

const actionObject: {
    actionList: IAction;
} = {
    actionList: {
        data: [],
    },
};

const isBrowser = typeof window !== 'undefined';

export const setLSAction = (value: IAction) => {
    if (isBrowser) {
        localStorage.setItem('qlub.tutorial.action', JSON.stringify(value));
    }
    actionObject.actionList = value;
};

export const getLSAction = (): IAction => {
    if (isBrowser) {
        const s = localStorage.getItem('qlub.tutorial.action');
        actionObject.actionList = parseJSON(s) || {
            data: [],
        };
    }
    return actionObject.actionList;
};

export const removeSSAction = () => {
    if (isBrowser) {
        localStorage.removeItem('qlub.tutorial.action');
    }
    actionObject.actionList.data = [];
};
